module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/pwl/work/assembla/beatfix.live/www/node_modules/axios/index.js
// module id = 38
// module chunks = 5